import React from "react";
import './App.css';
import AtletikLogo from "./Assets/AtletikLogo.png";

function App() {

  return (
    <div className="App" style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      textAlign: "center",
      padding: "20px",
      background: "linear-gradient(135deg, #020617, #1e3a8a)",
      color: "#fff"
    }}>
      <img src={AtletikLogo} alt="Seychelles Athletics" style={{ maxWidth: "300px", width: "100%" }} />
      <h1>Site is under construction</h1>
    </div>
  );
}

export default App;
